import { FC, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ViewResolver } from '@Components/ViewResolver';
import { ComparisonSheetState } from '@Features/MaterialRequest/requests/components/ComparisonSheet/ComparisonSheet.types';

import { composeSelectedOffers } from '@Features/MaterialRequest/requests/components/ComparisonSheet/utils';
import { comparisonSheetSuppliersSelector } from '@Features/MaterialRequest/requests/MaterialRequisition/store/selectors/materialRequestSelector';
import { useGetTenderTotalAmountQuery } from '@Features/MaterialRequest/requests/TenderRequest/store/api/TenderRequestApiSlice';
import MRFeatureRoutePath from '@Features/router/mr/MRFeatureRoutePath.enum';
import { useAppSelector } from '@Hooks/index';
import { useFormikContext } from 'formik';
import { NoData } from '@Components/RequestList/noData';
import SelectedTabDesktop from './desktop/SelectedTabDesktop';
import SelectedTabMobile from './mobile/SelectedTabMobile';

interface SelectedTabProps {}

const SelectedTab: FC<SelectedTabProps> = () => {
  const { tenderId } = useParams();
  const navigate = useNavigate();
  const { data: totalAmountData } = useGetTenderTotalAmountQuery(tenderId!, {
    skip: !tenderId,
  });

  const formik = useFormikContext<ComparisonSheetState>();
  const comparisonSheetSuppliers = useAppSelector(
    comparisonSheetSuppliersSelector
  );

  const handleReviewApprove = (): void => {
    formik.handleSubmit();
    navigate(`../${MRFeatureRoutePath.COMPARISON_SHEET_APPROVE}`);
  };

  const selectedSheetOffers = useMemo(() => {
    if (formik.values.allOffers && formik.values.selectedOffersIDs) {
      return composeSelectedOffers(
        formik.values.allOffers,
        formik.values.selectedOffersIDs
      );
    }
    return [];
  }, [formik.values.allOffers, formik.values.selectedOffersIDs]);

  if (!selectedSheetOffers || !comparisonSheetSuppliers) {
    return <NoData context="comparison-screen" />;
  }

  return (
    <ViewResolver
      desktop={
        <SelectedTabDesktop
          comparisonSheetSuppliers={comparisonSheetSuppliers}
          handleReviewApprove={handleReviewApprove}
          selectedSheetOffers={selectedSheetOffers}
          totalAmountData={totalAmountData}
        />
      }
      mobile={
        <SelectedTabMobile
          comparisonSheetSuppliers={comparisonSheetSuppliers}
          handleReviewApprove={handleReviewApprove}
          selectedSheetOffers={selectedSheetOffers}
          totalAmountData={totalAmountData}
          formik={formik}
        />
      }
    />
  );
};
export default SelectedTab;
